import React, { useState } from 'react'
import { useEffect, useRef } from "react";
import { Create_Api, formatEventDateTime, Get_Api } from '../API_URL';
import { toast } from 'react-toastify';
import { AnimatePresence, motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

function Events() {
  const navigate = useNavigate();
  const eventCardsRef = useRef(null);

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (eventCardsRef.current) {
        eventCardsRef.current.scrollBy({ left: 350, behavior: "smooth" });
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const [IsUploading, setIsUploading] = useState(false);
  const [AllEvents, setAllEvents] = useState([]);

  const Get_All_Events = async () => {
    try {
      setIsUploading(true);
      const response = await Get_Api('api/admin/GetAllEvents');
      setAllEvents(response?.data);
      setIsUploading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    Get_All_Events();
  }, []);

  const [showModal, setShowModal] = useState(false);

  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Number, setNumber] = useState('');
  const [Message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!Name) return toast.error('Name is required');
    if (!Email) return toast.error('Email is required');
    if (!Number) return toast.error('Number is required');
    if (!/^\d{10}$/.test(Number)) return toast.error('Number must be exactly 10 digits');
    if (!Message) return toast.error('Message is required');

    setIsUploading(true);

    const Data = {
      Name,
      Email,
      Number,
      Message
    }

    try {
      const response = await Create_Api('api/admin/CreateContactUs', Data);
      toast.success(response?.message || 'Contact Form Submitted!');
      setName('');
      setEmail('');
      setNumber('');
      setMessage('');
      navigate('/Thankyou');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to add Blogs.');
      console.error('Error creating Blogs:', error);
    } finally {
      setIsUploading(false);
    }
  };



  return (
    <>
      {IsUploading && (
        <div className="loading-text">Loading...</div>
      )}
      <div className="event-cards md:px-[135px] px-[20px]" ref={eventCardsRef}>
        {AllEvents?.map((event, index) => (
          <div>
            <div key={index} className="event-card">
              <img src={event?.Image || 'assets/home/img1.png'} alt={event?.Heading} />
              <div className="event-card-text">
                <h3>{event?.Heading}</h3>
                <p>
                  {event?.Description}
                </p>
                <button onClick={() => { setShowModal(true) }}>Join</button>
                <div className="event-time">
                  <p>{formatEventDateTime(event?.Date, event?.Time, event?.EndTime)}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <AnimatePresence>
        {showModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex: '100' }}>
            <motion.div
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -50 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              className="bg-white p-6 rounded-lg shadow-lg w-96"
            >
              <div className="modal-heading">
                <img style={{ height: '100px' }} src="/assets/logo.png" />
                <button
                  className="  "
                  onClick={() => setShowModal(false)}
                >
                  <i class="bi bi-x-circle"></i>
                </button>
              </div>
              <div className="modal-input">
                <input
                  placeholder="Enter Your Name"
                  className=""
                  value={Name}
                  onChange={(e) => { setName(e.target.value) }}
                />
                <input
                  placeholder="Enter Your Email"
                  className=""
                  value={Email}
                  onChange={(e) => { setEmail(e.target.value) }}
                />
                <input
                  placeholder="Enter Your Mobile No."
                  className=""
                  type="number"
                  value={Number}
                  onChange={(e) => { setNumber(e.target.value) }}
                />
                <textarea
                  placeholder="Enter Your Message"
                  className=""
                  value={Message}
                  onChange={(e) => { setMessage(e.target.value) }}
                />
                <button onClick={(e) => { handleSubmit(e) }}>
                  {IsUploading ? "Please Wait" : "Send"}
                </button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Events
